import { SfChevronForwardIcon } from 'fitify-ui/src/Icon/outline/SfChevronForwardIcon'
import { useTheme } from 'styled-components'

import {
  StyledFaq,
  StyledFaqAnswer,
  StyledFaqAnswerInner,
  StyledFaqAnswerText,
  StyledFaqHeader,
  StyledFaqQuestion,
  StyledFaqToggle,
} from './Faq.Styled'

export type FaqProps = {
  answer: string
  isOpen: boolean
  onToggle: () => void
  question: string
}

export const Faq = ({ answer, isOpen, onToggle, question }: FaqProps) => {
  const theme = useTheme()

  return (
    <StyledFaq>
      <StyledFaqHeader type="button" aria-expanded={isOpen} onClick={onToggle}>
        <StyledFaqQuestion
          as="span"
          $color={theme.colors['N Content/Primary']}
          $variant="Poppins/T3 - Medium"
        >
          {question}
        </StyledFaqQuestion>
        <StyledFaqToggle $isOpen={isOpen}>
          <SfChevronForwardIcon />
        </StyledFaqToggle>
      </StyledFaqHeader>
      <StyledFaqAnswer $isOpen={isOpen}>
        <StyledFaqAnswerInner>
          <StyledFaqAnswerText
            $color={theme.colors['N Content/Secondary']}
            $variant="Poppins/T4"
          >
            {answer}
          </StyledFaqAnswerText>
        </StyledFaqAnswerInner>
      </StyledFaqAnswer>
    </StyledFaq>
  )
}
